import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';

@Component({
    selector: 'fin-metabase-dashboard',
    standalone: true,
    imports: [CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './metabase-dashboard.component.html',
    styleUrls: ['./metabase-dashboard.component.scss']
})
export class MetabaseDashboardComponent implements OnInit {
    @Input() token = '';
    @Input() withTitle = true;
    @Input() withDownloads = true;
    @Input() initialParameters: string | Record<string, string | string[]> = {};

    get formattedInitialParameters(): string {
        if (!this.initialParameters) return '{}';
        if (typeof this.initialParameters === 'string') {
            try {
                JSON.parse(this.initialParameters);
                return this.initialParameters;
            } catch {
                return '{}';
            }
        }
        return JSON.stringify(this.initialParameters);
    }

    ngOnInit(): void {
        this.loadMetabaseScript();
    }

    private loadMetabaseScript(): void {
        const metabaseWindow = window as Window & { metabaseConfig?: unknown };
        metabaseWindow.metabaseConfig = {
            theme: { preset: 'light' },
            isGuest: true,
            instanceUrl: 'https://analytics.lokos.in'
        };

        const scriptId = 'metabase-embed-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://analytics.lokos.in/app/embed.js';
            script.defer = true;
            document.head.appendChild(script);
        }
    }
}
